import type { FicheColor } from '@pharmafiche/schema';

/**
 * Semantic color mapping shared across all templates.
 * A molecule keeps the same color across every template (CLAUDE.md §6.2).
 */
export const FICHE_COLOR_HEX: Record<FicheColor, string> = {
  blue: '#2e6cb5',
  green: '#3e9a5e',
  purple: '#8a4dbf',
  orange: '#e3823a',
  red: '#d34a4a',
  yellow: '#f5d24c',
  neutral: '#1f2330',
};

/** Tailwind class for text-color of a FicheColor */
export const FICHE_COLOR_TEXT: Record<FicheColor, string> = {
  blue: 'text-accent-blue',
  green: 'text-accent-green',
  purple: 'text-accent-purple',
  orange: 'text-accent-orange',
  red: 'text-accent-red',
  yellow: 'text-accent-yellow',
  neutral: 'text-ink',
};

/** Tailwind class for background-color of a FicheColor */
export const FICHE_COLOR_BG: Record<FicheColor, string> = {
  blue: 'bg-accent-blue',
  green: 'bg-accent-green',
  purple: 'bg-accent-purple',
  orange: 'bg-accent-orange',
  red: 'bg-accent-red',
  yellow: 'bg-accent-yellow',
  neutral: 'bg-ink',
};

/** Tailwind class for border-color of a FicheColor */
export const FICHE_COLOR_BORDER: Record<FicheColor, string> = {
  blue: 'border-accent-blue',
  green: 'border-accent-green',
  purple: 'border-accent-purple',
  orange: 'border-accent-orange',
  red: 'border-accent-red',
  yellow: 'border-accent-yellow',
  neutral: 'border-ink',
};
